<!--
  创建时间：2024/10/23 下午1:56
  创建人：toyeh
  文件描述：公告展示
-->

<template>
  <div class="notice mt-30">
    <block-head-line title="公告展示" hid-more-btn />
    <ul>
      <li v-for="item in dataList" :key="item.id" class="item">
        <Link :to="item.url" class="img-link" target="_blank" :title="item.title">
          <img :alt="item.title" :src="item.adImage">
          <div class="txt flex-center">
            <p class="el-2" :title="item.title">{{ item.title }}</p>
          </div>
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";
import adApi from "@/api/ad";
import { AD_CODE } from "@/utils/constant";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";

export default {
  name: "NoticeExhibition",
  components: { Link, BlockHeadLine },
  props: {
  },
  data() {
    return {
      dataList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
  },
  // 方法集合
  methods: {
    loadListData() {
      adApi.page({ pageNo: 1, pageSize: 5, type: AD_CODE.AD_NOTICE }).then((res) => {
        this.dataList = res.data.list;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.notice {
	width: 100%;
	.item{
		margin-top: 15px;
		width: 100%;
		border: 1px solid #ddd;
		img{
			width: 100%;
			height: 200px;
			//object-fit: contain;
			vertical-align: middle;
			display: block;
		}
		.txt{
			width: 100%;
			height: 60px;
			border-top: 1px solid #ddd;
			padding: 10px;
			p{
				width: 100%;
				color: #333;
				font-size: 14px;
				line-height: 18px;

			}
		}
		&:hover{
			opacity: 0.8;
		}
	}
}
</style>
